import {
  FormattedHTMLMessage,
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { getSplashEventList } from '../../../../ducks/events';
import { navigate } from '../../../../helpers';
import Loader from '../../components/Loader';
import Option from '../components/Option';
import styles from '../seatmap.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  event: PropTypes.shape({
    name: PropTypes.string,
    shortcode: PropTypes.string,
  }),
  events: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

class Events extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getSplashEventList());
  }

  render() {
    const {
      events,
      loading,
      history,
    } = this.props;

    const sortedEvents = events.slice().sort((a, b) => {
      const diff = moment(a.start).diff(b.start);
      return diff !== 0 ? diff : a.name.localeCompare(b.name);
    });

    const openUpcomingEvents = sortedEvents.filter((event) => (
      event.seatmap_published && moment(event.end).isSameOrAfter(moment().startOf('day'))
    ));

    const upcomingEventsWithPurchaseUrl = sortedEvents.filter((event) => (
      !event.seatmap_published && event.purchase_url && moment(event.end).isSameOrAfter(moment().startOf('day'))
    ));

    return (
      <>
        <Loader loading={loading} />
        { events
          && (
            <>
              <div className={styles.title}>
                <FormattedMessage
                  id="seatmap.events.title"
                  defaultMessage="What event do you want to manage tickets for?"
                />
              </div>
              <div className={styles.description}>
                <FormattedHTMLMessage
                  id="seatmap.events.description"
                  defaultMessage="The following <strong>{numEvents}</strong> {numEvents, plural, one {event} other {events}} are open for ticket management."
                  values={{
                    numEvents: openUpcomingEvents?.length,
                  }}
                />
              </div>
              { openUpcomingEvents.map((event) => (
                <Option
                  key={event.id}
                  icon="star"
                  title={event.name}
                  onClick={() => navigate(history, `/tickets/${event.shortcode}`)}
                />
              )) }
              <div className={styles.description}>
                <FormattedMessage
                  id="seatmap.events.notYourEvent"
                  defaultMessage="Not seeing your event? Some DreamHack event tickets are handled by third-party ticket vendors. Please go to the event website to get more information on tickets."
                />
              </div>
              { upcomingEventsWithPurchaseUrl
            && (
              <>
                <div className={styles.title}>
                  <FormattedMessage
                    id="seatmap.events.buySuggestions"
                    defaultMessage="Buy tickets"
                  />
                </div>
                { upcomingEventsWithPurchaseUrl.map((event) => (
                  <Option
                    key={event.id}
                    icon="shopping-basket"
                    title={event.name}
                    href={event.purchase_url}
                  />
                )) }
              </>
            )}
            </>
          )}
      </>
    );
  }
}

Events.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    events: state.getIn(['events', 'events']),
    error: state.getIn(['events', 'error']),
    loaded: state.getIn(['events', 'loaded']),
  };
}

export default injectIntl(withUser(connect(mapStateToProps)(Events)));
